import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material/';
import makeStyles from '@mui/styles/makeStyles';
import { useAppStore } from '../../store/AppStore';
import { ErrorBoundary, ResponsiveAppBar } from '../../components';
import SportsMenuSection from '../../views/components/SportsMenu';
import BetSlipWrapper from '../../views/components/BetSlip/BetSlipWrapper';
import PendingBetsWrapper from '../../views/components/PendingBets/PendingBetsWrapper';
import { useWallet } from '@solana/wallet-adapter-react';
import { ToastContainer } from 'react-toastify';

const TITLE_PUBLIC = 'Purebet - bet on the highest odds straight from your wallet';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh', // Full screen height
    paddingTop: 110, // on Small screen
    [theme.breakpoints.up('sm')]: {
      paddingTop: 110, // on Large screen
    },
  },
  header: {},
  sportsMenu: {
    [theme.breakpoints.down('hd')] : {
      minWidth: '100%'
    },
    [theme.breakpoints.up('md')] : {
      flex: "0 0 auto"
    },
  },
  betSlipColumn: {
    flex: "1 1 20%",
    minWidth: "280px",
    maxWidth: "425px",
    [theme.breakpoints.down('hp')] : {
      flex: "1 1 15%",
      maxWidth: '-webkit-fill-available'
    },
  },
  toolbar: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  title: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    flexGrow: 1,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  content: {
    flexGrow: 1, // Takes all possible space
    padding: theme.spacing(1),
  },
  footer: {},
}));

/**
 * "Link to Page" items in Sidebar
 */
const SIDE_BAR_PUBLIC_ITEMS = [
  {
    title: 'Log In',
    path: '/auth/login',
    icon: 'login',
  },
  {
    title: 'Sign Up',
    path: '/auth/signup',
    icon: 'signup',
  },
  {
    title: 'About',
    path: '/about',
    icon: 'info',
  },
];

/**
 * Renders "Main Layout" composition
 * @component MainLayout
 */
const MainLayout = ({ children }) => {
  const classes = useStyles();
  const [openSideBar, setOpenSideBar] = useState(false);
  const [state, dispatch] = useAppStore();
  const navigate = useNavigate();
  const wallet = useWallet();

  const title = TITLE_PUBLIC;
  document.title = title; // Also Update Tab Title

  const handleSwitchDarkMode = useCallback(() => {
    dispatch({
      type: 'SET_DARK_MODE',
      darkMode: !state.darkMode,
      payload: !state.darkMode,
    });
  }, [state, dispatch]);

  const handleSideBarOpen = useCallback(() => {
    if (!openSideBar) setOpenSideBar(true);
  }, [openSideBar]);

  const handleSideBarClose = useCallback(() => {
    if (openSideBar) setOpenSideBar(false);
  }, [openSideBar]);

  const handleBottomNavigationChange = (event, value) => {
    navigate(value);
  };

  // const initJupiter = () => {
  //   if (wallet?.connected) {
  //     if (window.Jupiter?._instance) {
  //       window.Jupiter.resume();
  //     } else {
  //       window.Jupiter.init({
  //         mode: 'outputOnly',
  //         mint: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v', //USDC Mint Address
  //         endpoint:
  //           process.env.REACT_APP_RPC_URL,
  //         passThroughWallet: wallet.wallet,
  //         displayMode: 'modal',
  //         containerStyles: { marginTop: '2rem' },
  //       });
  //     }
  //   } else if (!wallet.connected) {
  //     if (window.Jupiter?._instance) {
  //       window.Jupiter.close();
  //     }
  //   }
  // };

  // const handleGetUSDC = () => {
  //   initJupiter();
  // };

  return (
    <>
      <Grid container direction="column" className={classes.root}>
        <Grid item className={classes.header} component="header">
          <ResponsiveAppBar />
        </Grid>

        <Grid item className={classes.content} component="main">
          <ErrorBoundary name="Content">
            <Grid container spacing={2} justifyContent="space-between">
              <Grid item sm={12} md={2} className={classes.sportsMenu}>
                <SportsMenuSection />
              </Grid>

              <Grid item container sx={{flex: 1}}>
                {children}
              </Grid>

              <Grid item container className={classes.betSlipColumn} justifyContent="flex-end">
                <Grid item xs={12}>
                  <BetSlipWrapper />
                  <PendingBetsWrapper />
                </Grid>
              </Grid>
            </Grid>
          </ErrorBoundary>
        </Grid>
      </Grid>
      {/* <div
        style={{
          position: 'fixed',
          bottom: '0px',
          right: '0px',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          margin: '1rem',
          cursor: 'pointer',
        }}
        onClick={handleGetUSDC}
      >
        <Typography color="error" style={{ marginRight: '8px', fontWeight: 'bold' }}>
          Don't have USDC? Get some here!
        </Typography>
        <img src="/img/usdc-coin-icon.png" width="48" />
      </div>
      */}
      <ToastContainer
        position="bottom-left"
        autoClose={false}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default MainLayout;
